module.exports = __webpack_public_path__ + "img/horizontal_1_1_r_9006.c1c6bd94.png";